import { z } from 'zod'

export const RSecondaryCode = z.object({
	ICD10: z.string(),
	ICD10_Description: z.string(),
	// see contraStatus() for more information on this type
	Contra: z.nullable(z.string()).default(null),
	Source: z.nullable(z.string()),
	// there's other logic in the app for determining if the encounter can
	// move forward, so ignore this
	// Is_Unresolvable: z.optional(z.boolean()),
})
export type SecondaryCode = z.infer<typeof RSecondaryCode>
